import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'procesar-remito'
  },
  {
    path: 'procesar-remito',
    pathMatch: 'full',
    loadChildren: () => import('./pages/procesar-remito/procesar-remito.module').then( m => m.ProcesarRemitoPageModule)
  },
  {
    path: 'procesar-remito/:crmdId/:perIdCliente/:puntoVenta/:numeroRemito',
    pathMatch: 'full',
    loadChildren: () => import('./pages/procesar-remito/procesar-remito.module').then( m => m.ProcesarRemitoPageModule)
  },
  {
    path: 'fin-entrega-remito',
    loadChildren: () => import('./pages/fin-entrega-remito/fin-entrega-remito.module').then( m => m.FinEntregaRemitoPageModule)
  },
  {
    path: 'detalle-remito',
    loadChildren: () => import('./modals/detalle-remito/detalle-remito.module').then( m => m.DetalleRemitoPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
